import {PRIMARY_OUTLET, Router, UrlTree} from '@angular/router';

/** Menu destinations that are safe to reload in another business region. */
const LIST_PATHS = new Set([
  '/site/list',
  '/device/list',
  '/device/dongle-list',
  '/device/event',
  '/device/battery',
  '/device/model',
  '/device/firmware',
  '/device/grid-codes',
  '/device/sgcc-csrs',
  '/device/iot-mqtt-data-list',
  '/device-group/list',
  '/isp/list',
  '/system-status/notification-list',
  '/system-status/audit-log-list',
  '/account-management/user-list',
  '/account-management/role-list',
]);

/** Keep list state; detail IDs and tab state belong to the old region and must be discarded. */
export function regionSwitchTarget(router: Router, currentUrl: string, region: string): UrlTree {
  const current = router.parseUrl(currentUrl);
  const segments = current.root.children[PRIMARY_OUTLET]?.segments ?? [];
  const path = '/' + segments.map(segment => segment.path).join('/');
  if (LIST_PATHS.has(path)) {
    current.queryParams = {...current.queryParams, region};
    return current;
  }

  let destination: string;
  switch (segments[0]?.path) {
    case 'site': destination = '/site/list'; break;
    case 'device-group': destination = '/device-group/list'; break;
    case 'isp': destination = '/isp/list'; break;
    case 'account-management':
      destination = segments[1]?.path === 'role'
        ? '/account-management/role-list' : '/account-management/user-list';
      break;
    case 'device':
      switch (segments[1]?.path) {
        case 'dongle': destination = '/device/dongle-list'; break;
        case 'firmware': destination = '/device/firmware'; break;
        case 'grid-codes': destination = '/device/grid-codes'; break;
        default: destination = '/device/list';
      }
      break;
    default: destination = '/site/list';
  }
  return router.createUrlTree([destination], {queryParams: {region}});
}
